// @ts-strict-ignore
import { EDITOR_ROUTE_PATHS } from '../../app.routes.constant';
import { UI_STRINGS } from '../../functions/language/uistrings';
import { EditorTree } from './editor-tree';

export enum EditorTreeType {
  Consumption = 'consumption',
  Economics = 'economics',
  Inventory = 'inventory',
  GPC = 'gpc',
  Resources = 'resources',
  ActivityHierarchy = 'activity-hierarchy',
}

export interface NavigationTreeData extends ViewParameters {
  tree: EditorTree;
  trees: { [key in EditorTreeType]: EditorTree };
}

export interface ViewParameters {
  availableTreeTypes: EditorTreeType[];
  activeTreeType: EditorTreeType;
  view: string;
  treeTitles?: { [key in EditorTreeType]?: string };
  dropdownSelector?: boolean;
  dropdownLabel?: string;
  multiSelect?: boolean;
  mirrorContent?: boolean;
  activateValidationDots?: boolean;
}

export const VIEW_PARAMETERS: {
  [view: string]: Omit<ViewParameters, 'activeTreeType' | 'view'>;
} = {
  [EDITOR_ROUTE_PATHS.INTERVENTIONS.CHILDREN.INTERVENTIONS]: {
    availableTreeTypes: [EditorTreeType.Consumption, EditorTreeType.Resources],
  },
  [EDITOR_ROUTE_PATHS.INVENTORIES.CHILDREN.ECONOMICS]: {
    availableTreeTypes: [EditorTreeType.Economics],
  },
  [EDITOR_ROUTE_PATHS.INVENTORIES.CHILDREN.HISTORICAL_EMISSIONS.ROOT]: {
    availableTreeTypes: [EditorTreeType.Consumption],
    activateValidationDots: true,
  },
  [EDITOR_ROUTE_PATHS.TRANSITIONS.CHILDREN.TRANSITION_TARGETS]: {
    availableTreeTypes: [EditorTreeType.Consumption],
  },
  [EDITOR_ROUTE_PATHS.TRANSITIONS.CHILDREN.ENERGY_MODEL]: {
    availableTreeTypes: [EditorTreeType.Resources],
  },
  [EDITOR_ROUTE_PATHS.DASHBOARD.CHILDREN.TRANSITION_STORIES]: {
    availableTreeTypes: [EditorTreeType.Consumption],
  },
  [EDITOR_ROUTE_PATHS.DASHBOARD.CHILDREN.EMISSION_STORIES]: {
    availableTreeTypes: [EditorTreeType.ActivityHierarchy],
  },
  [EDITOR_ROUTE_PATHS.INVESTMENT_PLAN]: {
    availableTreeTypes: [EditorTreeType.Consumption],
    mirrorContent: true,
  },
  [EDITOR_ROUTE_PATHS.INVENTORIES.CHILDREN.ACTIVITY_INVENTORIES]: {
    availableTreeTypes: [EditorTreeType.GPC, EditorTreeType.ActivityHierarchy],
    multiSelect: false,
    dropdownSelector: true,
    dropdownLabel: UI_STRINGS.EDITOR_TREE.ACTIVITY_HIERARCHY,
  },
  [EDITOR_ROUTE_PATHS.INVENTORIES.CHILDREN.SOCIOECONOMIC_PARAMETERS]: {
    availableTreeTypes: [EditorTreeType.Inventory],
  },
  [EDITOR_ROUTE_PATHS.TRANSITIONS.CHILDREN.ACTIVITY_OUTCOME]: {
    availableTreeTypes: [EditorTreeType.ActivityHierarchy, EditorTreeType.GPC],
    dropdownSelector: true,
    dropdownLabel: UI_STRINGS.EDITOR_TREE.ACTIVITY_HIERARCHY,
  },
};

export const VIEW_PARAMETERS_DEFAULT: Omit<ViewParameters, 'activeTreeType' | 'view'> = {
  availableTreeTypes: [EditorTreeType.Consumption],
  multiSelect: false,
  activateValidationDots: false,
};

export const EDITOR_TREE_INITIAL: EditorTree = {
  id: undefined,
  title: undefined,
  children: [],
  expandable: undefined,
};
